import { useStore, useStoreMap } from 'effector-react'
import { balanceModel } from '~/entities/Balance'
import { CURRENCY } from '~/shared/config/constants'
import { ProgressBlock } from '~/shared/ui/Loaders'
import { myPalette } from '~/shared/ui/theme'
import { Wrapper } from './styled'

export function AmountAll() {
  const isAmountAllLoading = useStore(balanceModel.getAvailableFundsFx.pending)
  const { amount, amountWithCommission } =
    useStore(balanceModel.$availableFunds) || {}

  const selectedPayCard = useStoreMap(
    balanceModel.$selectedPayCard,
    (payCard) => payCard?.getAttributes(),
  )

  const renderSum = (sum?: number | null) => {
    return isAmountAllLoading ? (
      <ProgressBlock height={16} size={16} color='midnightBlue' />
    ) : (
      (sum || 0).toLocaleString()
    )
  }

  if (!selectedPayCard) {
    return (
      <div style={{ fontSize: '12px', color: myPalette.mutedText.main }}>
        Лимит будет рассчитан после выбора карты
      </div>
    )
  }

  return (
    <>
      <Wrapper>
        <div style={{ fontSize: '12px', marginRight: '6px' }}>С комиссией</div>
        <div>{renderSum(amount)}</div>
        <div style={{ marginLeft: '6px' }}>{CURRENCY}</div>
      </Wrapper>

      <Wrapper style={{ height: '48px' }}>
        <div style={{ fontSize: '32px', fontWeight: 500, marginRight: '8px' }}>
          {renderSum(amountWithCommission)}{' '}
        </div>
        <div style={{ fontSize: '24px', fontWeight: 500 }}>{CURRENCY}</div>
      </Wrapper>
    </>
  )
}
